import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';
import { ClipboardService } from '../services/clipboard.service';
import { ToasterService } from '../toaster-module/toaster-service/toaster.service';

@Directive({
  selector: '[appClipboard]',
})
export class ClipboardDirective implements AfterViewInit {

  constructor(private el: ElementRef, private clipboardService: ClipboardService, private toasterService: ToasterService) {

  }

  @HostListener('click') onClick() {
    let textToCopy: string = this.el.nativeElement.parentElement.previousSibling.textContent;
    this.clipboardService.copyToClipboard(textToCopy);
    textToCopy = this.clipboardService.removeSpaces(textToCopy);
    this.toasterService.startToast(4, 'success', ['Overeenkomstnummer ' + textToCopy + ' gekopiëerd naar klembord.'], false);
  }

  ngAfterViewInit(): void {
    if (!this.el.nativeElement.parentElement.previousSibling.textContent) {
      this.el.nativeElement.style.display = 'none';
    }
  }

}
